/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useState } from "react";
import { strings } from "../../../common/Strings/Strings";
import { PlusIcon } from "../../../common/Icons/PlusIcon";
import ClickOutsideDetector from "../../../components/ClickOutsideDetector";

interface Props {
  openNewReservationModal(): void,
  openNewShiftModal(): void;
  setIsEmergency(value: boolean): void;
}

const AddDropdown: React.FC<Props> = ({ openNewReservationModal, openNewShiftModal, setIsEmergency }: Props) => {
  const [menuDropOpen, setMenuDropOpen] = useState<boolean>(false);
  return (
    <div>
      <ClickOutsideDetector
        listen
        onClickOutside={() => {
          setMenuDropOpen(false);
        }}
      >
        <button
          type="button"
          className="tw-btn-circle-primary rounded"
          onClick={() => {
            setMenuDropOpen((prev) => !prev);
          }}
        >
          <PlusIcon />
          <span className="sr-only">Plus</span>
        </button>
        <div
          hidden={!menuDropOpen}
          className="z-30 shadow-md rounded-lg w-46 font-normal bg-white divide-y divide-gray-100 dark:bg-gray-700 dark:divide-gray-600 absolute top-0 right-0 m-0"
          style={{ transform: "translate(-24px, 75px)" }}
        >
          <ul className="py-2 text-md text-gray-700 dark:text-gray-400">
            <li>
              <button
                className="tw-link flex justify-between items-center px-4 py-2 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-300 w-full"
                onClick={() => {
                  openNewReservationModal();
                  setIsEmergency(true);
                }}
                type="button"
              >
                {strings.emergencyAppointment}
              </button>
            </li>
            <li>
              <button
                className="tw-link flex justify-between items-center px-4 py-2 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-300 w-full"
                onClick={() => openNewReservationModal()}
                type="button"
              >
                {strings.newReservation}
              </button>
            </li>
            <li>
              <button
                className="tw-link flex justify-between items-center px-4 py-2 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-300 w-full"
                onClick={() => openNewShiftModal()}
                type="button"
              >
                {strings.newShift}
              </button>
            </li>
          </ul>
        </div>
      </ClickOutsideDetector>
    </div>
  );
};

export default AddDropdown;